import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { Observable } from 'rxjs';
import { ShipmentWaybillNotificationsState } from './shipment-waybill-notifications.state';
import {
  ShipmentWaybillNotificationsLoad,
  ShipmentWaybillNotificationsSetInitialState,
} from './shipment-waybill-notifications.actions';
import { WaybillIdView } from '../../../../models';
import { LatestNotification } from '../../../monitoring/models';

@Injectable({ providedIn: 'root' })
export class ShipmentWaybillNotificationsFacade implements LoadDataFacade, SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(ShipmentWaybillNotificationsState.getLoaded);
  notifications$: Observable<LatestNotification[]> = this.store.select(
    ShipmentWaybillNotificationsState.getNotifications,
  );

  constructor(private store: Store) {}

  loadAll(identifier: WaybillIdView): void {
    this.store.dispatch(new ShipmentWaybillNotificationsLoad(identifier));
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentWaybillNotificationsSetInitialState());
  }
}
